module.exports = {
	"name": "Berlin",
	"slug": "berlin",
	"description": "A junction between vibrant culture, intense night-life, edgy architecture and art, Berlin is a city filled with things to do and places to visit. Follow the girls to this giant lab of cultural trendsetting.",
	"hotspots": [
		{
			"name": "Urban Spree",
			"description": "A combination of an art space, a night-club, the Urban Spree is a place always full of people, colors and life. The building changes outfits regularly to homage the current exhibition, painted and repainted, usually designed by the same artist or studio of artists the show is about. Live music and an art bookstore can also be found in this distinct and unique place. The outdoor area invites people to sit around under the lights and linger enjoying the very particular setting.",
			"url": "http://www.urbanspree.com/",
			"lat": 52.507633,
			"long": 13.454361,
			"type": "record"
		},
		{
			"name": "Populous Coffee",
			"description": "More than a coffee shop, Populus Coffee is a little piece of Finland. The place itself has a warm home-like vibe that coupled with a distinctive decoration style, invites people to say “I’ll stay a little bit longer’. Between the clair pastel colors, the green plants scattered around and the friendly staff, Populus Coffee is a parenthesis in busy life of Berlin. Visitors can enjoy a delicious cup of coffee (roasted by Populus Coffee) along with nordic style treats in a cosy and welcoming environment.",
			"url": "https://www.instagram.com/populus_coffee/",
			"lat": 52.49369,
			"long": 13.42704,
			"type": "coffee"
		},
		{
			"name": "Street Art Workshop",
			"description": "Alternative Berlin offers a different way to see street art in Berlin: the Street Art Workshop. This two part tour take the guests to first discovers latest, greatest and oldest examples of street art to then, visit the workshop location (in an abandoned factory) where they’ll be able to create their own piece of art. The guides in the Street Art Workshop are all street artists, giving context and telling what is behind each piece of art, the best way to unravel Berlin’s arty soul.",
			"url": "http://alternativeberlin.com/tours/berlin-graffiti-workshop-and-street-art-tour/",
			"lat": 52.520815,
			"long": 13.409419,
			"type": "gallery"
		},
		{
			"name": "Your Space",
			"description": "Located in the backyard of an old factory Your Space is a bubble in time where the guests can not only enjoy yoga and meditation classes, but where the emphasis is put on granting room for creativity, inspiration and sharing the lessons learnt. The “Tribe”, as they describe themselves, is composed of dancers, astrologists, raw food specialists and healers, all prepared to receive visitor with their brightest smile.",
			"url": "http://www.yourspaceberlin.com/",
			"lat": 52.53248,
			"long": 13.4215,
			"type": "health"
		},
		{
			"name": "Markthelle Neun",
			"description": "Opened for the first time 125 years ago, this historic market welcomes people to having all kinds of food you can think of. It starts with a traditional market until Thursday were visitors can enjoy ‘Street Food Thursday’ in the evening. Various stalls compete with each other while the customers have a hard time deciding what is best to eat. Every third Sunday of the month the ‘Breakfast Market’ is held, featuring all sorts of goodies from local producers and cooks and everything you need to prepare breakfast. Finally, the ‘Nachmarkt’ comes to live once a quarter, an enormous snack market, or Heaven for those with a sweet tooth.",
			"url": "https://markthalleneun.de/",
			"lat": 52.50202,
			"long": 13.43186,
			"type": "market"
		},
		{
			"name": "Claustrophobia",
			"description": "Even if escape games are not a novelty, Claustrophobia propose something different: a visually stimulating and physically immersive game. The visitor has to choose between two scenarios: The Museum of Contemporary Art, where in a pitch black night, the quest is to snatch the most valuable exhibit and vanish, or the Vault 13, where survivors of a nuclear war attempt to break out of a decaying underground shelter. 60 minutes of non-stop thrills and fun.",
			"url": "https://berlin.claustrophobia.com/en/#landing_quest_list",
			"lat": 52.519903,
			"long": 13.414795,
			"type": "game"
		}
	],
	"cities": [
		{
			"name": "amsterdam",
			"img": "/media/img/cities/amsterdam_thumb.jpg",
			"url": "/city/amsterdam"
		},
		{
			"name": "london",
			"img": "/media/img/cities/london_thumb.jpg",
			"url": "/city/london"
		}
	],
	"media": [
		"/media/img/cities/berlin/berlin_slider-2.jpg",
		"/media/img/cities/berlin/berlin_slider-4.jpg",
		"/media/img/cities/berlin/berlin_slider-3.jpg",
		"/media/img/cities/berlin/berlin_slider-1.jpg"
	]
};


//////////////////
// WEBPACK FOOTER
// ./data/cities/berlin.json
// module id = 71
// module chunks = 0